const Env = {
  ...process.env,
  ...(window as any)._env_
};

export default Env;
